import OrderItem from './OrderItem.view';

export default OrderItem;
